export default [
    //FOR Finance Manager========================================================================
    {
        subject: "roles",
        gotApprovalProcess: false,
        key: "role", //this is the parameter found in the url /form/:key 
        pageTitle: "User Roles",
        editPage: "edit_form",  //the route to point when user select the add or edit button in the table
        previewPage: "view_form", //the route to point when user select the row in the table
        tableSettings: {
            route: "groups",
            formType: "General",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
               // status: "PO Pending Approval",
            },
            // filterEndpoint: "getPOByStatus",
            showAddBtn: true,
            showActionButton: true, //if this is false the add and edit button will not be shown 
            showEditBtn: false,

        },
    },
   
    //------------------------------------------------------------------------------------------
]